import config from "../../utils/config";
import { authIrrobaService } from "./auth.service";

export const apiFetcher = (storeId, at, path, init, attempt = 1) => {

    let url = `${config.MOBILIZEI_API_BASE_URL}/platforms/irroba/api_forward/${path}`;

    if (!init?.headers) init = { ...init, headers: {} }
    init.headers['Authorization'] = at;

    init.headers['Content-Type'] = 'application/json';

    return fetch(url, init).then(response => {
        if (response.status === 204) {
            return;
        }
        return response.json().then(data => {
            if (!response.ok) {
                if (response.status === 401  && attempt <= 3) {
                    return authIrrobaService.refreshAccessToken(storeId)
                        .then(accessToken => {
                            return apiFetcher(storeId, accessToken, path, init, attempt + 1);
                        })
                        .catch((error) => {
                            return Promise.reject(error);
                        });
                }
                const error = data || response.statusText;
                return Promise.reject(error);
            }

            return data;
        })
    })
        .catch(error => {
            if (attempt <= 3) {
                return apiFetcher(storeId, at, path, init, attempt + 1);
            }

            return Promise.reject(error);
        });
};